<template>
  <!-- eslint-disable -->
  <div class="component">
    <div class="aside">
      <div class="aside__logo_and_nav">
        <div class="aside__logo_row">
          <router-link
            :to="{ name: 'Calculator' }">
            <img
            class="aside__logo"
            src="@/assets/img/max_box_1.png"
            alt="Max Box Logo"
          /></router-link>
        </div>

        <div class="aside__nav" :class="isNavOpen ? 'is-open' : ''">
          <div class="aside__nav_toggle" @click="openNav">
            <b-icon icon="menu" />
          </div>

          <div class="aside__nav_links o-horizontal_list o-horizontal_list--l">
            <a
              href="http://www.constalica.com/"
              class="aside__nav_link t-label t-label--small"
              >&lt; {{ $t("Voltar a constalica.com") }}</a
            >
            <router-link
              :to="{ name: 'Calculator' }"
              v-if="!isCalculator"
              class="aside__nav_link t-label t-label--small"
              >{{ $t("Recomeçar simulador") }}</router-link
            >
            <router-link
              @click.native="handleAccountLinkClick"
              :to="{ name: 'Solutions' }"
              class="aside__nav_link t-label t-label--small"
              >{{ $t("A minha conta") }}</router-link
            >
            <router-link
              :to="{ name: 'Logout' }"
              v-if="user"
              class="aside__nav_link t-label t-label--small"
              >{{ $t("Logout") }}</router-link
            >
          </div>
        </div>
      </div>

      <div class="aside__body_row">
        <slot name="aside"></slot>
      </div>

      <div class="aside__footer_row">
        <div class="aside__lang_select o-horizontal_list o-horizontal_list--s">
          <span
            class="aside__lang_select_option"
            @click="handleLangClick(lang)"
            :class="selectedLang === lang ? 'is-active' : ''"
            v-for="lang in langs"
            :key="lang"
            >{{ lang.toUpperCase() }}</span
          >
        </div>

        <div class="aside__copyright_and_terms_link">
          <div class="aside__copyright">© Constálica {{ new Date().getYear() + 1900}}</div>
          <router-link
            class="aside__terms_link"
            :to="{ name: 'Terms-Conditions' }">
            {{ $t("Termos e condições") }}
            </router-link>

          <div>
            <router-link
            class="aside__terms_link"
            :to="{ name: 'Privacy-Policy' }">
            {{ $t("POLÍTICA DE PRIVACIDADE") }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="content_col">
      <div class="content_col__nav_row">
        <div>
          <a href="http://www.constalica.com/" class="t-label t-label--small"
            >&lt; {{ $t("Voltar a constalica.com") }}</a
          >
        </div>

        <div
          class="
            content_col__nav_desktop
            o-horizontal_list o-horizontal_list--l
          "
        >
          <router-link
            :to="{ name: 'Calculator' }"
            v-if="!isCalculator && user"
            class="
              content_col__nav_desktop__link
              t-label t-label--small t-label--dark
            "
            >{{ $t("Recomeçar simulador") }}</router-link
          >
          <router-link
            @click.native="handleAccountLinkClick"
            v-if="user"
            :to="{ name: 'Solutions' }"
            class="
              content_col__nav_desktop__link
              t-label t-label--small t-label--dark
            "
            >{{ $t("A minha conta") }}</router-link
          >
          <router-link
            :to="{ name: 'Logout' }"
            v-if="user"
            class="
              content_col__nav_desktop__link
              t-label t-label--small t-label--dark
            "
            >{{ $t("Logout") }}</router-link
          >
        </div>
      </div>

      <slot name="body"></slot>
      <b-modal :active.sync="isModalIntroOpen">
        <modal-intro />
      </b-modal>
    </div>

    <div class="footer_row">
      <div class="footer__lang_select o-horizontal_list o-horizontal_list--s">
        <span
          class="footer__lang_select_option"
          @click="handleLangClick(lang)"
          :class="selectedLang === lang ? 'is-active' : ''"
          v-for="lang in langs"
          :key="lang"
          >{{ lang.toUpperCase() }}</span
        >
      </div>

      <div class="footer__copyright_and_terms_link o-horizontal_list">
        <div class="t-label t-label--small t-label--dark footer__terms_link">
          {{ $t("Termos e condições") }}
        </div>
        <div class="t-label t-label--small t-label--dark footer__copyright">
          © Constálica {{ new Date().getYear() + 1900}}
        </div>
      </div>
    </div>

    <b-modal :active.sync="isModalAuthOpen">
      <modal-auth />
    </b-modal>

    <cookie-banner v-if="!cookies"/>
    
  </div>
  <!-- eslint-enable -->
</template>

<script>
import { mapState, mapActions } from "vuex";
import { debounce } from "@/utils";
import ModalAuth from "@/components/ModalAuth";
import {ModalIntro} from "@/components";
import { langsIdxs } from "@/i18n";
import CookieBanner from '../components/CookieBanner.vue';

export default {
  components: {
    ModalAuth,
    ModalIntro,
    CookieBanner,
  },

  data() {
    return {
      langs: ["pt", ...Object.keys(langsIdxs)],
      isModalAuthOpen: false,
      isNavOpen: false,
      isModalIntroOpen: false,
    };
  },
  computed: {
    ...mapState(["user", "selectedLang","hasSeenIntro","cookies"]),

    isCalculator() {
      return this.$route.name === "Calculator";
    },
  },

  methods: {
    ...mapActions(["updateAccount", "updateSelectedLang", "initCookie"]),

    debouncedUpdateUser: debounce(function ({ lang }) {
      this.user && this.updateAccount({ lang });
    }, 5000),

    handleLangClick(lang) {
      this.updateSelectedLang(lang);
      this.debouncedUpdateUser({ lang });
    },

    handleAccountLinkClick() {
      if (this.user) {
        this.$router.push({ name: "Solutions" });
      } else {
        this.$buefy.modal.open({
          component: ModalAuth,
        });
      }
    },

    openModalAuth() {
      this.isModalAuthOpen = true;
    },

    openNav() {
      this.isNavOpen = !this.isNavOpen;
    },

    shouldShowIntro() {
      return !this.user && !this.hasSeenIntro;
    },
  },
  created(){
    if (this.shouldShowIntro()) {
      this.isModalIntroOpen = true;
    }

    this.initCookie();
  },
};
</script>

<style lang="scss">
html,
body,
#app {
  height: 100%;
}

html {
  background-color: #efefef;
}
</style>

<style lang="scss" scoped>
.component {
  font-family: $font-family-primary;
  font-size: 14px;
  line-height: 19px;
  min-height: 100%;
}

$width-aside: 352px;
$page-side-padding: 16px;
$page-top-padding: 32px;
$page-bottom-padding: 16px;

.aside,
.content_col {
  min-height: 100%;
}

.aside__nav_link,
.content_col__nav_desktop__link,
.content_col__nav_desktop__link,
.footer__terms_link {
  cursor: pointer;
}

.aside {
  display: flex;
  flex-direction: column;
  flex: 0 0 $width-aside;
  background-color: $black-2;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: $width-aside;
  padding-top: $page-top-padding;
  padding-bottom: $page-bottom-padding;
  background-image: url("../assets/img/cubo.png");
  background-repeat: no-repeat;
  background-size: auto 300px;
  background-position: center 90%;
}

.aside__block  {
  @include pad("horizontal", $page-side-padding);
}

.aside__logo_and_nav {
  @include pad("horizontal", $page-side-padding);
  display: flex;
  justify-content: space-between;
  margin-bottom: 68px;
}

.aside__logo {
  vertical-align: bottom;
  height: 50px;
}

.aside__body_row {
  @include pad("horizontal", $page-side-padding);
  overflow: auto;
  flex-grow: 1;
}

.aside__footer_row {
  @include pad("horizontal", $page-side-padding);
  padding-top: $page-side-padding;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.aside__lang_select_option {
  display: inline-block;
  font-family: $font-family-title;
  letter-spacing: 0.7px;
  font-size: 12px;
  text-decoration-line: underline;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;

  &.is-active {
    font-weight: 700;
  }
}

.aside__copyright_and_terms_link {
  text-align: right;
  cursor: pointer;
}

.aside__copyright,
.aside__terms_link {
  text-align: right;
  font-family: $font-family-title;
  text-transform: uppercase;
  color: $black-4;

  font-size: 10px;
  line-height: 15px;
  letter-spacing: 0.7px;
}

.aside__copyright {
  margin-bottom: 2px;
}

.aside__terms_link {
  text-decoration: underline;
}

.content_col {
  position: relative;
  padding: $page-top-padding $page-side-padding $page-bottom-padding;
  margin-left: $width-aside;
  // overflow: hidden;
}

.content_col__nav_row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 64px;
}

.footer_row {
  background-color: $black-6;
  padding: 19px $page-side-padding 27px;
}

.footer__lang_select {
  white-space: nowrap;
  padding-right: 1em;
}

.footer__lang_select_option {
  font-family: $font-family-title;
  text-decoration: underline;
  color: $black-2;
  cursor: pointer;
}

.footer__lang_select_option.is-active {
  font-weight: 600;
}

.footer__copyright_and_terms_link {
  text-align: right;
}

//responsive
.aside__nav,
.footer_row {
  display: none;
}

@media screen and (max-width: 1408px) {
  .component {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  .aside {
    position: static;
    width: auto;
    padding-bottom: 23px;
    flex: 0;
  }

  .aside__logo_and_nav {
    margin-bottom: 32px;
  }

  .aside__body_row {
    overflow: visible;
  }

  .aside__footer_row {
    display: none;
  }

  .content_col {
    flex-grow: 1;
    margin-left: 0;
    padding-bottom: 24px;
  }

  .content_col__nav_row {
    display: none;
  }

  .aside__nav_link:hover {
    color: #fff;
  }

  .aside__nav {
    display: block;
  }

  .footer_row {
    display: flex;
    justify-content: space-between;
  }
}

.aside__nav {
  $root: &;
  $mobile-menu-background: #121212;
  position: relative;
  z-index: 5;

  &_toggle {
    display: none;
    padding: 6px;
    margin-top: -6px;
    cursor: pointer;
  }

  &_link {
    white-space: nowrap;
  }

  @media screen and (max-width: 840px) {
    &_toggle {
      display: block;
    }

    &_links {
      display: none;
      position: absolute;
      top: 100%;
      right: 0;
      background-color: $mobile-menu-background;
      padding: 15px 0;
    }

    &_link {
      display: block;
      text-align: left;
      margin-left: 0;
      padding: 3px 13px;
    }

    &.is-open {
      #{$root}_toggle {
        background-color: $mobile-menu-background;
      }

      #{$root}_links {
        display: block;
      }
    }
  }
}
</style>
